import { toast } from "react-toastify";
import create from "zustand";
import { config } from "../alerts/index";
import { auth } from "../../../../config/firebase.config.js";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
export const useStore = create((set, get) => ({
  user: null,
  loginDetails: async (payload) => {
    try {
      const user = await signInWithEmailAndPassword(
        auth,
        payload.formDetails.email,
        payload.formDetails.password
      );
      localStorage.setItem("active-liv-user", user.user.uid);
      toast("Signed in", { ...config, type: "success" });
      set({ user: user });
    } catch (error) {
      toast("Password or email are incorrect.", { ...config, type: "error" });
      console.log(error.message);
    }
  },
  userSignOut: async () => {
    try {
      await signOut(auth);
      set({ user: null });
      localStorage.removeItem('active-liv-user')
      toast("Logged out successfully.", {
        ...config,
        type: "success",
      });
    } catch (error) {
      toast("Something went wrong ", { ...config, type: "error" });
      console.log(error.message);
    }
  },
}));
